var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteSorry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6356_62362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.021 30.623H19.5588C18.1629 30.6239 16.8245 31.1788 15.8375 32.1658C14.8505 33.1528 14.2957 34.4912 14.2948 35.887V130.814C14.2957 132.21 14.8505 133.548 15.8375 134.535C16.8245 135.522 18.1629 136.077 19.5588 136.078H123.021C124.417 136.077 125.755 135.523 126.742 134.536C127.729 133.549 128.284 132.21 128.285 130.814V35.887C128.284 34.4911 127.729 33.1526 126.742 32.1656C125.755 31.1786 124.417 30.6238 123.021 30.623Z",
    fill: "#E3ECFB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6356_62362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.209 103.091H26.3703C23.4633 103.091 21.1063 100.734 21.1063 97.8271V13.9539C21.1063 11.0469 23.4633 8.68994 26.3703 8.68994H116.209C119.116 8.68994 121.473 11.0469 121.473 13.9539V97.8271C121.473 100.734 119.116 103.091 116.209 103.091Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.7729 99.4936V15.621C22.7729 12.7139 25.1298 10.357 28.0369 10.357H117.876C118.903 10.357 119.857 10.6554 120.666 11.1637C119.736 9.67973 118.09 8.69043 116.209 8.69043H26.3703C23.4633 8.69043 21.1063 11.0474 21.1063 13.9544V97.8275C21.1063 99.7088 22.0956 101.354 23.5796 102.285C23.0713 101.475 22.7729 100.521 22.7729 99.4941V99.4936Z",
    fill: "url(#paint0_linear_6356_62362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.156 26.4116H37.4248V30.2715H105.156V26.4116ZM105.156 41.15H37.4248V45.0099H105.156V41.15ZM105.156 55.8917H37.4248V59.7516H105.156V55.8917ZM105.156 70.6301H37.4248V74.4906H105.156V70.6301Z",
    fill: "#DEE9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4963 58.1714L62.5161 75.1917H45.4963V58.1714Z",
    fill: "url(#paint1_linear_6356_62362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.285 76.5952V37.4346L121.473 30.6226V76.5946L128.285 76.5952Z",
    fill: "#E3ECFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.263 80.1376L128.924 132.088C128.557 134.685 126.335 136.615 123.712 136.615H18.8668C16.244 136.615 14.0214 134.685 13.6545 132.088L3.737 61.8904C3.28964 58.7214 5.74876 55.8899 8.94931 55.8899H41.3277C43.9505 55.8899 46.1731 57.8201 46.54 60.4168L47.8397 69.6097C48.2066 72.2068 50.4293 74.1371 53.052 74.1371H131.052C134.251 74.1371 136.711 76.9685 136.264 80.1376H136.263Z",
    fill: "#B4DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.261 113.443H32.3185C31.8913 113.443 31.4788 113.287 31.1583 113.005C30.8378 112.722 30.6313 112.333 30.5774 111.909L29.6023 104.188C29.5713 103.941 29.5932 103.69 29.6665 103.452C29.7398 103.214 29.8629 102.995 30.0275 102.808C30.1922 102.621 30.3946 102.472 30.6215 102.369C30.8484 102.267 31.0944 102.214 31.3433 102.214H111.236C111.485 102.214 111.731 102.267 111.958 102.369C112.185 102.472 112.387 102.621 112.552 102.808C112.716 102.995 112.839 103.214 112.913 103.452C112.986 103.69 113.008 103.941 112.977 104.188L112.002 111.909C111.948 112.333 111.741 112.722 111.421 113.005C111.1 113.287 110.688 113.443 110.261 113.443Z",
    fill: "#1485FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6356_62362",
    x: 11.1063,
    y: -4.31006,
    width: 120.367,
    height: 114.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6356_62362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6356_62362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6356_62362",
    x1: 74.3764,
    y1: 58.9719,
    x2: 7.80512,
    y2: -7.59989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6356_62362",
    x1: 56.7412,
    y1: 77.9226,
    x2: 36.1686,
    y2: 57.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6356_62362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSorry);
export default __webpack_public_path__ + "static/media/deleteSorry.e88327aed94342d4130daa2968eb1cbe.svg";
export { ForwardRef as ReactComponent };